export const reportConstants = {
 
    GET_PAST_MONTH_SALES_DATA_REQUEST: 'GET_PAST_MONTH_SALES_DATA_REQUEST',
    GET_PAST_MONTH_SALES_DATA_SUCCESS: 'GET_PAST_MONTH_SALES_DATA_SUCCESS',
    GET_PAST_MONTH_SALES_DATA_FAILURE: 'GET_PAST_MONTH_SALES_DATA_FAILURE',

    GET_REVENUE_SITE_DATA_REQUEST: 'GET_REVENUE_SITE_DATA_REQUEST',
    GET_REVENUE_SITE_DATA_SUCCESS: 'GET_REVENUE_SITE_DATA_SUCCESS',
    GET_REVENUE_SITE_DATA_FAILURE: 'GET_REVENUE_SITE_DATA_FAILURE',

    GET_MONTH_REQUEST: 'GET_MONTH_REQUEST',
    GET_MONTH_SUCCESS: 'GET_MONTH_SUCCESS',
    GET_MONTH_FAILURE: 'GET_MONTH_FAILURE',

};


// WEBPACK FOOTER //
// ./src/app/redux/constants/reportConstants.js